export default __webpack_public_path__ + "static/media/game_3.6487911e.bin";